import { Box, Card, CardContent, Skeleton } from "@mui/material";

export const PieChartSkeleton = () => (
    <Card elevation={1} sx={{ height: '100%', borderRadius: 2 }}>
        <CardContent>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height={400}>
                {/* Circular skeleton to simulate pie chart */}
                <Skeleton variant="circular" width={280} height={280} sx={{ pb: 3 }} />
            </Box>

            {/* Label placeholders below the pie chart */}
            <Box display="flex" flexDirection="column" justifyContent="center" height="100%">
                {Array.from({ length: 4 }).map((_, idx) => (
                    <Box
                        key={idx}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        mb={1.5}
                    >
                        <Skeleton variant="text" width="60%" height={20} />
                        <Skeleton variant="text" width={40} height={20} />
                    </Box>
                ))}
            </Box>
        </CardContent>
    </Card>
);